<div class="stripe-card-item-container">
    <img src="assets/payments/{{cardBrand}}.svg">
    <div>....{{lastFour}}</div>
    <p>{{translatorSvc.getLabel('payNow')}}</p>
</div>
